import React from "react";
import * as S from "./CitajteoStart.styled";
import { useErrorBoundary } from "react-error-boundary";

// const CitajteoStart = () => {
//   const { showBoundary } = useErrorBoundary();

//   return (
//     <div>
//       <div>START</div>
//       <div>Citajteo</div>
//     </div>
//   );
// };

// export default CitajteoStart;

const museumData = [
  {
    name: "OKTOBARSKI SALON",
    text: "je izložba reprezentativnih dela iz sfere aktuelnog stvaralaštva u oblasti vizuelnih umetnosti, koja ima status stalne manifestacije u oblasti kulture od značaja za Grad Beograd.Savet Moderne galerije (koja je s vremenom prerasla u Muzej savremene umetnosti u Beogradu) na osnovu svog statuta i akta Sekretarijata za prosvetu i kulturu Narodnog odbora grada Beograda na sednici održanoj 19. maja 1960. godine doneo je rešenje o osnivanju Oktobarskog salona.",
    image: "images/oktobarski_salon.jpg",
    link: "/g/oktobarski-salon",
    width: 220,
    height: 326,
  },
  {
    name: "PETAR LUBARDA",
    text: "je rođen 1907. u Ljubotinju nedaleko od Cetinja, od oca Đura I. Lubarde, oficira crnogorske vojske, a potom potpukovnika Vojske Kraljevine Jugoslavije, i majke Marije M. Vujović, domaćice. Imao je petoro braće i sestara.",
    image: "images/umetnik_1_srednja3.jpg",
    link: "/g/petar-lubarda",
    width: 220,
    height: 173,
  },
  {
    name: "SAVA ŠUMANOVIĆ",
    text: "je rođen 24. januara 1896. u Vinkovcima u imućnoj građanskoj porodici, Perside i Milutina Šumanovića. Posle ranog očevog penzionisanja 1900. porodica se vraća u Šid, gde Sava pohađa osnovnu školu.",
    image: "images/umetnik_2_srednja3.jpg",
    link: "/g/sava-sumanovic",
    width: 220,
    height: 172,
  },
  {
    name: "MUZEJ SAVREMENE UMETNOSTI",
    text: "1948. godine je Raspisan prvi (uži) konkurs za zgradu Moderne galerije na levoj obali reke Save. Prvu nagradu na konkursu su dobili arhitekti Edvard Ravnikar i Veljko Kauzlarić. Druga nagrada pripala je arhitekti Branku Petričiću. Projekat nije realizovan.",
    image: "images/g/muzej_01_2.jpg",
    link: "/g/muzej-savremene-umetnosti",
    width: 220,
    height: 220,
  },
  {
    name: "AVANGARDA",
    text: "U februaru 1921.godine počinje da izlazi časopis Zenit – Internacionalna revija za umetnost i kulturu. Urednik Ljubomir Micić. U prvom broju časopisa Zenit izlazi Zenitistički manifest Ivana Golla pisan na nemačkom i Manifest zenitizma čiji su potpisnici Ljubomir Micić, Ivan Goll i Boško Tokin. Zenit uspostavlja aktivnu saradnju sa Arhipenkom osnivačem umetničke škole u Berlinu. ",
    image: "images/g/04_avangarda_srednja2.jpg",
    link: "/g/avangarda",
    width: 220,
    height: 306,
  },
  {
    name: "NADEŽDA PETROVIĆ",
    text: "je rođena 11. oktоbra 1873. u Čačku. Otac Dimitrije Mita Petrović bio je nastavnik crtanja u Realnoj gimnaziji u Čačku, a majka Mileva učiteljica. Nadežda je bila najstarije od devetoro dece.",
    image: "images/nadezda-petrovic-s3.jpg",
    link: "/g/nadezda-petrovic",
    width: 220,
    height: 326,
  },
  {
    name: "KONCEPTUALNA UMETNOST",
    text: "Hronologija konceptualne umetnosti u Jugoslaviji",
    image: "/images/g/Naslovna foto konceptualna_2.jpg",
    link: "/g/konceptualna-umetnost",
    width: 220,
    height: 319,
  },
];

const CitajteoStart: React.FC = () => {
  return (
    <S.Container>
      <S.Row>
        <S.Col>
          <S.ArtistWrapper>
            {museumData.map((museum, index) => (
              <S.ArtistRow key={index} $last={index === museumData.length - 1}>
                <S.ImageColumn>
                  <S.Link href={museum.link}>
                    <S.Image
                      src={museum.image}
                      alt={museum.name}
                      width={museum.width}
                      height={museum.height}
                    />
                  </S.Link>
                </S.ImageColumn>

                <S.TextColumn>
                  <S.ArtistText>
                    <S.ArtistName>{museum.name}</S.ArtistName>
                    <p>{museum.text}</p>
                    <S.Link href={museum.link}>dalje...</S.Link>
                    <S.Link href={museum.link}>
                      <S.ArrowIcon
                        src="images/strelica.jpg"
                        alt="Strelica"
                        width={15}
                      />
                    </S.Link>
                  </S.ArtistText>
                </S.TextColumn>
              </S.ArtistRow>
            ))}
          </S.ArtistWrapper>
        </S.Col>
      </S.Row>
    </S.Container>
  );
};

export default CitajteoStart;
